import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormatNumberService } from 'src/app/shared/utils/format-number.service';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { RescueDataModel } from 'src/app/shared/models/rescue-data.model';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { PostValidateService } from 'src/app/shared/services/post-validate/post-validate.service';
import { IdentificationService } from 'src/app/shared/services/identification/identification.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers-onboarding.service';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { getAppStatus } from 'single-spa';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
var CaptureDataComponent = /** @class */ (function () {
    /**
     * Constructor de componente
     *
     * *Component constructor*
     * @param formBuilder
     * @param navigationService
     * @param abreCuentasService
     * @param headerService
     * @param copyService
     * @param {ChannelCommunicatorService} channelCommunicatorService Injectable channelCommunicatorService service.
     * @param {ParametersService}          ParametersService          Injectable parametersServices service
     */
    function CaptureDataComponent(formBuilder, navigationService, abreCuentasService, headerService, copyService, formatNumber, channelCommunicatorService, parametersService, taggingServices, bitacoraService, loaderService, postValidateService, identificationService, helperService, captureService, taggingService) {
        this.formBuilder = formBuilder;
        this.navigationService = navigationService;
        this.abreCuentasService = abreCuentasService;
        this.headerService = headerService;
        this.copyService = copyService;
        this.formatNumber = formatNumber;
        this.channelCommunicatorService = channelCommunicatorService;
        this.parametersService = parametersService;
        this.taggingServices = taggingServices;
        this.bitacoraService = bitacoraService;
        this.loaderService = loaderService;
        this.postValidateService = postValidateService;
        this.identificationService = identificationService;
        this.helperService = helperService;
        this.captureService = captureService;
        this.taggingService = taggingService;
        /**
         * Texto de error para campo de telefono
         *
         * *Error text for phone field*
         *
         * @access public
         * @type {string}
         */
        this.reactiveErrorPhone = '';
        /**
         * Texto de error para campo de email
         *
         * *Error text for email field*
         *
         * @access public
         * @type {string}
         */
        this.reactiveErrorEmail = '';
        /**
         * Texto de error para campo de cédula
         *
         * *Error text for email field*
         *
         * @access public
         * @type {string}
         */
        this.reactiveErrorClientName = '';
        /**
         * Texto de error para campo de cédula
         *
         * *Error text for email field*
         *
         * @access public
         * @type {string}
         */
        this.reactiveErrorClientId = '';
        /**
         * Objeto de información de contacto
         *
         * *Information contact object*
         *
         * @access public
         * @type {ContactModel}
         */
        // contactInfo: ContactModel;
        /**
         * Variable de validación para mostrar modal
         *
         * *Validation variable to showModal*
         *
         * @access public
         * @type {boolean}
         */
        this.showModal = false;
        /**
         * Copies de los labels del modal
         *
         * *Labels modal copies*
         *
         * @access public
         * @type {Object}
         */
        this.buttonLabelsModal = {};
        this.activeInput = false;
        this.birthdayDate = '';
        this.expeditionDate = '';
        /**
         * Valida si el input esta habilitado o no
         *
         * *Validates if the input is enabled or not*
         */
        this.advisorCodeInput = false;
        this.headerService.show(false, false, true);
        this.formGroup = this.formBuilder.group({});
        this.buttonLabelsModal = {
            primary: copyService.copies.back_document_modal_button_primary,
        };
        this.rescueData = new RescueDataModel();
    }
    /**
     * Función de Angular ejecutada una vez el componente sea cargado, carga los productos a mostrar
     *
     * *Angular function that is run when the component is loaded, charges products to be displayed*
     */
    CaptureDataComponent.prototype.ngOnInit = function () {
        if (!this.abreCuentasService.rescueDataIsEmpty()) {
            this.getRescueData();
        }
        else {
            this.postValidateService.solicitationId();
        }
        console.log('///** IS CLIENT ' + this.abreCuentasService.getAbreCuentasModel().isPostlogin + '-- ' + this.abreCuentasService.getproductSelected().product_type);
        this.setForm();
        this.setDatePicker();
        this.initRadio();
        this.genderOptions = this.parametersService.getBusinessRule('gender_type');
        this.listAdvisor = [{
                label: this.copyService.copies.advisor_code_yes,
                elementId: 1,
                checked: this.abreCuentasService.getAdvisorCheck() === '1' ? true : false,
                value: true,
            },
            {
                label: this.copyService.copies.advisor_code_no,
                elementId: 2,
                checked: this.abreCuentasService.getAdvisorCheck() === '2' ? true : false,
                value: false,
            }];
        this.advisorCodeInput = this.abreCuentasService.getAdvisorCheck() === '1' ? true : false;
        this.activeInput = this.abreCuentasService.getAdvisorCheck() === '1' ? true : false;
        this.vendorCodeNumber = this.abreCuentasService.getAdvisorCode();
        this.formGroup.controls.codeAdvisor.setValue(this.vendorCodeNumber);
        this.terms = {
            text: this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].description,
            title: this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].code,
            terms_id: this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].id,
        };
        this.postLogin = this.abreCuentasService.getPostlogin();
        this.productSelected = this.abreCuentasService.getproductSelected();
        this.product_type = this.productSelected.product_type;
        if (this.abreCuentasService.getProductsSelects().length >= 2 && !this.postLogin) {
            this.steps = this.parametersService.getSetting(OpEnum.REVOLVING_STEPS_MULTI);
        }
        else if (this.postLogin && this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE
            || this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC
            || this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING
            || this.product_type === BUSINESS_CONST.MULTI) {
            this.steps = this.parametersService.getSetting(OpEnum.REVOLVING_STEPS_POST);
        }
        else {
            this.steps = this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING ? this.parametersService.getSetting(OpEnum.LIVING_STEPS)
                : this.parametersService.getSetting(OpEnum.REVOLVING_STEPS);
        }
        var status = getAppStatus('simulator');
        status === 'MOUNTED' ? this.helperService.unRegisterAplication('simulator') : console.log();
        this.loaderService.hide('null');
        this.previous();
    };
    CaptureDataComponent.prototype.setDatePicker = function () {
        var date_e = new Date();
        date_e.setMonth(date_e.getMonth() - 216);
        this.minDateBirth = this.helperService.formatDateCalendar(date_e);
        date_e = new Date();
        date_e.setMonth(date_e.getMonth() - 888);
        this.maxDateBirth = this.helperService.formatDateCalendar(date_e);
        this.minDateExp = this.helperService.formatDateCalendar(new Date());
        date_e = new Date();
        date_e.setMonth(date_e.getMonth() - 600);
        this.maxDateExp = this.helperService.formatDateCalendar(date_e);
    };
    CaptureDataComponent.prototype.setForm = function () {
        this.formGroup = new FormGroup({
            email: new FormControl(this.rescueData.email, [
                Validators.required,
                Validators.pattern(
                // tslint:disable-next-line
                /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/),
            ]),
            phone: new FormControl(this.rescueData.mobile_number, [
                Validators.required,
                Validators.pattern(/^3\d{9}$/),
                this.formatNumber.numberPhoneValidator()
            ]),
            client_name: new FormControl(this.rescueData.client_name, Validators.required),
            client_lastname: new FormControl(this.rescueData.client_lastname, Validators.required),
            number_id: new FormControl(this.rescueData.number_id, [
                Validators.required,
                Validators.minLength(2),
            ]),
            adviser: new FormControl([]),
            codeAdvisor: new FormControl(''),
            birthdayDate: new FormControl(''),
        });
    };
    /**
     * Se ejecuta cada vez que hay un cambio sobre el campo de nombre
     *
     * *It executes each time there is a change on cédula field*
     */
    CaptureDataComponent.prototype.inputClientName = function () {
        this.rescueData.client_name = this.formGroup.controls.client_name.value.trim();
        var controlClientName = this.formGroup.controls.client_name;
        this.reactiveErrorClientName = controlClientName.valid ? '' : this.copyService.copies.form_capture_name_error;
    };
    /**
     * Se ejecuta cada vez que hay un cambio sobre el campo de apellido
     *
     * *It executes each time there is a change on cédula field*
     */
    CaptureDataComponent.prototype.inputClientLastname = function () {
        this.rescueData.client_lastname = this.formGroup.controls.client_lastname.value.trim();
        var controlClientLastname = this.formGroup.controls.client_lastname;
        this.reactiveErrorClientName = controlClientLastname.valid ? '' : this.copyService.copies.form_capture_lastname_error;
    };
    /**
     * Se ejecuta cada vez que hay un cambio sobre el campo de cédula
     *
     * *It executes each time there is a change on cédula field*
     */
    CaptureDataComponent.prototype.inputClientId = function () {
        this.rescueData.number_id = this.formGroup.controls.number_id.value;
        var controlClientId = this.formGroup.controls.number_id;
        this.reactiveErrorClientId = controlClientId.valid ? '' : this.copyService.copies.form_capture_id_error;
    };
    CaptureDataComponent.prototype.selectOption = function (event) {
        this.genderStatus = event.value.short_name;
    };
    CaptureDataComponent.prototype.getNumberFormat = function (value) {
        // const formatNumber = new FormatNumberService();
        return this.formatNumber.formatNumberPhone(value);
    };
    /**
     * Se ejecuta cada vez que se inicia la edición de número de teléfono
     *
     * *It executes each time begins the phone editing*
     */
    CaptureDataComponent.prototype.inputPhone = function ($event) {
        var value = $event.target.value;
        var phone = this.getNumberFormat(value);
        $event.target.value = phone.clearValue;
    };
    /**
     * Se ejecuta cada vez que termina la edición de número de teléfono
     *
     * *It executes each time finish the phone editing*
     */
    CaptureDataComponent.prototype.outPhone = function ($event) {
        var value = $event.target.value;
        var phone = this.getNumberFormat(value);
        $event.target.value = phone.format;
        this.rescueData.mobile_number = phone.clearValue;
    };
    /**
     * Se ejecuta cada vez que hay un cambio sobre el campo de email
     *
     * *It executes each time there is a change on email field*
     */
    CaptureDataComponent.prototype.reactiveInputChangeEmail = function () {
        this.rescueData.email = this.formGroup.controls.email.value;
        var controlEmail = this.formGroup.controls.email;
        this.reactiveErrorEmail = controlEmail.valid ? '' : this.copyService.copies.form_contact_email_error;
    };
    CaptureDataComponent.prototype.initRadio = function () {
        if (this.abreCuentasService.getAdvisorCheck() === '') {
            this.listAdvisor = {
                label: this.copyService.copies.advisor_code_no,
                elementId: 2,
                checked: true,
                value: false,
            };
            this.abreCuentasService.setAdvisorCheck(this.advisorCodeInput === true ? '1' : '2');
        }
        else if (this.abreCuentasService.getAdvisorCheck() === '1') {
            this.listAdvisor = {
                label: this.copyService.copies.advisor_code_yes,
                elementId: 1,
                checked: true,
                value: true,
            };
            this.abreCuentasService.setAdvisorCheck(this.advisorCodeInput === true ? '2' : '1');
        }
    };
    CaptureDataComponent.prototype.selectAdvisorCode = function () {
        this.abreCuentasService.setAdvisorCheck(this.advisorCodeInput === true ? '1' : '2');
        this.advisorCodeInput = !this.advisorCodeInput;
        if (this.advisorCodeInput) {
            this.formGroup.controls['codeAdvisor'].setValidators([
                Validators.required,
                Validators.minLength(4), Validators.maxLength(12),
                Validators.pattern(new RegExp(/^[Ññ\w-#/.,´´ ]+$/)),
            ]);
        }
        else {
            this.formGroup.controls['codeAdvisor'].clearValidators();
        }
        this.formGroup.controls['codeAdvisor'].updateValueAndValidity();
    };
    CaptureDataComponent.prototype.reactiveInputChangeCode = function (event) {
        var InputControl = this.formGroup.controls['codeAdvisor'];
        var valueInput = InputControl.value;
        var currentInput = event.data;
        var validInputValidator = new RegExp(/^[0-9-]*$/g);
        if (!validInputValidator.test(currentInput) && currentInput) {
            InputControl.setValue(valueInput.replace(currentInput, ''));
            return;
        }
        this.abreCuentasService.setAdvisorCode(valueInput);
        this.vendorCodeNumber = valueInput;
    };
    CaptureDataComponent.prototype.reactiveOnFocus = function () {
        this.activeInput = true;
    };
    CaptureDataComponent.prototype.reactiveDatePicker = function (e) {
        this.birthdayDate = e.target.value;
        this.date_button = e.target.value !== '' ? true : false;
    };
    CaptureDataComponent.prototype.expeditionDatePicker = function (event) {
        this.expeditionDate = event.target.value;
        this.date_button = event.target.value !== '' ? true : false;
    };
    /**
     * Acción del modal
     *
     * *Modal action*
     *
     * @param event
     * @type {function}
     */
    CaptureDataComponent.prototype.modalAction = function (event) {
        if (event.type === 'primary') {
            this.downloadPdf();
        }
    };
    /**
     * Servicio para enviar datos a Google analytics
     *
     * *Send data to Google Analytics*
     */
    CaptureDataComponent.prototype.toggleModal = function () {
        // this.downloadPdf();
        var tagPageName = this.navigationService.getCurrentStep().tag_name;
        try {
            var changes = [
                {
                    path: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionDetailsProductcategory"].path,
                    value: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionDetailsProductcategory"].value,
                },
                {
                    path: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionName"].path,
                    value: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionName"].value,
                },
            ];
            var event_1 = {
                category: {
                    module: EVENT.customCategory.module.body,
                    type: EVENT.customCategory.type.link,
                    position: EVENT.customCategory.position.top,
                },
                action: EVENT.customAction.click,
                label: EVENT[tagPageName + "E1customLabel"],
            };
            this.taggingServices.pageTagEvent(event_1, changes);
        }
        catch (error) {
            console.log("Error en: " + error);
        }
        this.showModal = !this.showModal;
        if (this.showModal) {
            this.navigationService.pageLoadTag(false, ['pv5', 'pv109', 'pv69', '']);
        }
    };
    /**
     * Método para descargar el PDF
     *
     * *Method to download pdf*
     */
    CaptureDataComponent.prototype.downloadPdf = function () {
        this.channelCommunicatorService.getImpl().openPdf(this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].pdfUrl);
    };
    CaptureDataComponent.prototype.previous = function () {
        this.back = '';
        if (this.abreCuentasService.getProductsSelects().find(function (product) { return product.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN; })) {
            if (this.abreCuentasService.getProductsSelects().length >= 2) {
                this.back = '200';
            }
            else {
                this.back = '205';
            }
        }
    };
    /**
     * Se ejecuta cada vez que de se da clic en continuar, debe llenar información de contacto e ir a la siguiente pantalla
     *
     * *It executes each time there is a click on continue, it should fill conctact information and go to the next screen*
     */
    CaptureDataComponent.prototype.next = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loaderService.show('capture-data');
                        this.sendTagging('next', 'bottom', '2');
                        this.saveDataRescue();
                        this.validateUser();
                        return [4 /*yield*/, this.sendBitacora()];
                    case 1:
                        _a.sent();
                        this.validateAdvisorCode();
                        return [2 /*return*/];
                }
            });
        });
    };
    CaptureDataComponent.prototype.validateAdvisorCode = function () {
        this.abreCuentasService.setAdvisorCheck(this.advisorCodeInput === true ? '1' : '2');
        if (this.advisorCodeInput) {
            this.abreCuentasService.setAdvisorCode(this.vendorCodeNumber);
        }
    };
    CaptureDataComponent.prototype.sendBitacora = function () {
        var bitacoraEvent = "assisted_selling_" + (this.advisorCodeInput ? "yes_" + this.vendorCodeNumber : 'no');
        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
        this.bitacoraService.saveDataInBitacora("celular_" + this.rescueData.mobile_number);
        this.bitacoraService.saveDataInBitacora("mail_" + this.rescueData.email);
        this.bitacoraService.saveDataInBitacora("Term_conditions_accept_");
        this.bitacoraService.saveDataInBitacora("nombre_" + this.rescueData.client_name);
        this.bitacoraService.saveDataInBitacora("apellido_" + this.rescueData.client_lastname);
        this.bitacoraService.saveDataInBitacora("cedula_" + this.rescueData.number_id);
        this.bitacoraService.saveDataInBitacora("Term_conditions_accept_");
    };
    CaptureDataComponent.prototype.saveDataRescue = function () {
        this.abreCuentasService.setRescueData(this.rescueData);
        var contactInfo = {
            mobile_number: this.rescueData.mobile_number,
            email: this.rescueData.email,
        };
        this.abreCuentasService.setContactInfo(contactInfo);
    };
    CaptureDataComponent.prototype.validateUser = function () {
        var _this = this;
        console.log('///** BIRTHDAY ' + this.birthdayDate);
        var lastname = this.rescueData.client_lastname.replace(/  +/g, ' ');
        var firstName = this.rescueData.client_name.replace(/  +/g, ' ');
        var personalData = {
            firstname: firstName.split(' ')[0],
            primary_lastname: lastname.split(' ')[0],
            middlename: firstName.substring(firstName.split(' ')[0].length + 1, firstName.length),
            second_lastname: lastname.substring(lastname.split(' ')[0].length + 1, lastname.length),
            document_number: this.rescueData.number_id,
            document_type: 'CC',
            email: this.rescueData.email,
            phones: [this.rescueData.mobile_number],
            birthdate: this.birthdayDate,
            sex: this.genderStatus,
            date_of_issue: this.expeditionDate,
        };
        console.warn('Consumiendo SendBackDocument, data: ', personalData);
        this.identificationService.sendBackDocumentInfo(personalData);
        this.statusSendBackDocument$ = this.identificationService.statusSendBackDocument$.subscribe(function (status) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('Resp SendBack_ ', status);
                        if (!status.error) return [3 /*break*/, 1];
                        this.navigationService.navigateToGeneralInformation(status.code);
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.check(status.code)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        this.statusSendBackDocument$.unsubscribe();
                        this.loaderService.hide('capture-data');
                        return [2 /*return*/];
                }
            });
        }); });
    };
    CaptureDataComponent.prototype.sendTagging = function (value, position, event, extras) {
        var page = '27';
        this.taggingService.sendTaggValues(value, page, position, event, extras);
    };
    /**
     * Valida la información inicial de contacto y si no existe pone los valores en vacio
     *
     * *Validates initial contact information and it does not exist it puts void values*
     */
    CaptureDataComponent.prototype.getRescueData = function () {
        this.rescueData = this.abreCuentasService.getRescueData();
    };
    CaptureDataComponent.prototype.check = function (nextCode) {
        var _this = this;
        if (this.productSelected.code === '201') {
            if (this.abreCuentasService.getUserJemelii()) {
                nextCode = '201';
            }
            var occupation = this.parametersService.getSetting(OpEnum.OCCUPATIONS_LIST)[0];
            this.abreCuentasService.setOccupationSelected(occupation);
            console.log('occupation', occupation);
            console.log('setOccupationSelected', this.abreCuentasService.getOccupationSelected());
            this.captureService.sendProspectOccupation().then(function (res) {
                console.log('res', res);
                if (!res) {
                    return;
                }
                _this.abreCuentasService.setinfoInferredIncomes(res.body.data);
                if (!res.status || res.status === 500) {
                    _this.navigationService.navigateToGeneralInformation('500');
                }
                else if (res.statusCode !== 200) {
                    var codigo = res.body.data.codigo;
                    switch (codigo) {
                        case '422-06':
                            nextCode = '500';
                            break;
                        case '422-07':
                            nextCode = '500';
                            break;
                        case '400':
                            nextCode = '500';
                            break;
                    }
                    _this.abreCuentasService.caseInfoError(nextCode);
                }
            }).catch(function () { return _this.navigationService.navigateToGeneralInformation('500'); });
        }
        else if (this.abreCuentasService.getUserJemelii()) {
            nextCode = '201';
        }
        else if (this.abreCuentasService.getSolicitationId() !== '') {
            nextCode = '200';
        }
        this.navigationService.nextStep(nextCode);
    };
    return CaptureDataComponent;
}());
export { CaptureDataComponent };
